import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const ProfileContent = lazy(() => import('./ProfileContent'));



const Profile = () => {
    return (  
        <Suspense fallback={<DefaultLoader />}>
            <ProfileContent />
        </Suspense>
    );
}

export default Profile;
